<template>
  <div class="common-box border-t0">
    <el-row class="row-one">
      <span class="row-one-title">查看合同</span>
      <Reback class="row-one-fr" @click.native="returnOne"></Reback>
    </el-row>
    <ul class="contract">
      <li>
        <img src="../../../assets/images/tViewer.png" alt="">
        <a :href="hrefOne" target="_block">普通投资者告知书</a>
      </li>
      <li>
        <img src="../../../assets/images/tViewer.png" alt="">
        <a :href="hrefTwo" target="_block">基金风险揭示书</a>
      </li>
      <li>
        <img src="../../../assets/images/tViewer.png" alt="">
        <a @click="hrefThree" target="_block">电子交易服务协议</a>
      </li>
      <li>
      </li>
    </ul>
    <el-button type="normal" style="margin:0 0 20px 490px" @click="returnTwo">返回个人中心</el-button>

  </div>
</template>

<script>
export default {
  data () {
    return {
      message: '',
      hrefOne: '',
      hrefTwo: '',
    }
  },
  created () {
    this.message = this.$route.params.message
    this.getcontract(this.message.APPSHEETSERIALNO ? this.message.APPSHEETSERIALNO : this.message.OrderNum)
  },
  mounted () {

  },
  methods: {
    returnOne () {
      this.$router.push({
        name: 'privateRecordDetail',
        params: {
          message: this.message
        }
      })
    },
    returnTwo () {
      this.$router.push({
        name: 'myAssets'
      })
    },
    getcontract (APPSHEETSERIALNO) {
      this.$http.post(this.$apiPath.privateContract, {
        orderNum: APPSHEETSERIALNO
      }).then(res => {
        // console.log(res);
        if (res.status !== 200 && res.data.code !== '200') return
        if (res.data.data.length > 0) {//返回值不为空
          // 投资者告知书
          this.hrefOne = 'https://apptrade.myfund.com:9091/appwebnew/pdf/' + this.message.CUSTFULLNAME + this.message.CERTIFICATENO + res.data.data.noticeBook3 + '3.png'
          // 风险揭示书
          this.hrefTwo = 'https://apptrade.myfund.com:9091/appwebnew/pdf/' + this.message.CUSTFULLNAME + this.message.CERTIFICATENO + res.data.data.noticeBook2 + '2.png'
        } else {
          // 投资者告知书
          this.hrefOne = 'https://apptrade.myfund.com:9091/appwebnew/pdf/' + this.message.CUSTFULLNAME + this.message.CERTIFICATENO + '3.png'
          // 风险揭示书
          this.hrefTwo = 'https://apptrade.myfund.com:9091/appwebnew/pdf/' + this.message.CUSTFULLNAME + this.message.CERTIFICATENO + '2.png'
        }
        // console.log(res);
      })
    },
    hrefThree () {
      const { href } = this.$router.resolve({
        name: 'agreementElectronicSever',
        query: {
          userName: this.message.name
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.contract {
  width: 600px;
  margin: 50px auto;
  li {
    display: inline-block;
    width: 50%;
    height: 50px;
    // background: pink;
    text-align: center;
    line-height: 50px;
    a {
      margin-left: 10px;
      cursor: pointer;
    }
    a:hover {
      color: @color;
    }
  }
}
</style>